import React, {Component} from 'react';

import Select from 'react-select';

import Usuario from './../api/Usuario'; 

const usuario = new Usuario(); 

class SelectEstudiantes extends Component {
    constructor(){
        super();
        this.state = {
            listado : [],
        }
    }
    
    async componentDidMount () {

        let listado = await usuario.estudiantes(); 
        this.setState({listado: listado}); 

    }

    render(){
        const {estudiante, maneja, invalido, isDisabled} = this.props;  
        const {listado} = this.state;

        const customStyles = {
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ?
                '#ddd' : !invalido?
                '#ddd' : 'red',
                '&:hover': {
                borderColor: state.isFocused ?
                    '#ddd' : !invalido?
                    '#ddd' : 'red'
                }

            })
          }
  
        return (
            <span>
                 <Select 
                    styles={customStyles}
                    value={estudiante} 
                    onChange={maneja}
                    isClearable={true} 
                    options={listado} 
                    placeholder="RUT o Nombre"  
                    noOptionsMessage={() => "No se encontraron resultados"}
                    isDisabled={isDisabled}
                    /> 
            </span>
        )
    }
};

export default SelectEstudiantes;